import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7e95fa16"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "navbar_logo" };
const _hoisted_2 = ["width", "height", "src"];
import { useStore } from '@/store/store';
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        width: { default: 400 }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const src = ref(`assets/trade/logo_${store.getters.theme}.png`);
        watch(() => store.state.theme, () => {
            src.value = `assets/trade/logo_${store.getters.theme}.png`;
        });
        const width = store.state.isSmartPhone ? props.width * 0.9 : props.width;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                    width: _unref(width),
                    height: _unref(width) / 3,
                    src: src.value
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
